import { useDispatch, useSelector } from "react-redux";
import { addLTExtension ,removeLTExtension} from "../../../action/building_component/buildingComponent.action";
import { Checkbox } from '@rmwc/checkbox';
import { capitalize } from "../../../redux/reducers/utils";

const AddLTExtension = () => {

   const params = useSelector((state) => state.reducer.params);
   const is_loader = useSelector((state) => state.reducer.const_var.is_loader);

   const dispatch = useDispatch()

  	const handleCheckbox = async (e, leanType) => {
		e.preventDefault();
		e.stopPropagation();
      
		if(params.leanStyle[leanType] === 'standard') {
         await dispatch(addLTExtension(leanType));
      } else {
		   await dispatch(removeLTExtension(leanType));
      }
	};


   return (
      <div className={'building-card-footer'}>
         <div className='add-lnt-action'>
            <div className="action-heading">Add L/T Shape to Your Building</div>
            <div className="action-subtext">Choose the side to attach an L or T shaped extension to your selected building</div>
            <div className='lnt-options'>
               {['left', 'right', 'front', 'back'].map(item => {

                  const isDisabled = is_loader || (params[`add_${item}_lean`] ? params.leanStyle[item] === 'standard' : false)

                  return (
                     <Checkbox
                        className={isDisabled ? 'disabled' : ''}
                        disabled={isDisabled}
                        checked={params.leanStyle[item] === 'gable'}
                        label={capitalize(item)}
                        onChange={(e) => handleCheckbox(e, item)}
                     />
                  )
               })}
               
            </div>
         </div>
      </div> 
   )                    
}

export default AddLTExtension